import { Container, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";
import { Heading } from "@chakra-ui/react";
import ProjectsCard from "./ProjectsCard";
import etm from "../../assets/screensort-1.png";
import bsm from "../../assets/screensort-2.png";
import touristguide from "../../assets/screensort-3.png";
import conventionhall from "../../assets/screensort-4.png";
import teleapp from "../../assets/screensort-6.jpg";
import ecommerce from "../../assets/screensort-5.png";
import { Link } from "react-router-dom";
const Projects = ({ home, size }) => {
  const projects = [
    {
      screen: etm,
      name: "Electronics Manufacturer Tools (Full Stack)",
      title: "An Online Buy Electronics Manufacturer Tools",
      about:
        "This is the platform where you can buy the electronics manufacturer tools very easily",
      git: "https://github.com/Jubair-Ahmed-Junjun/emt-client",
      server: "https://github.com/Jubair-Ahmed-Junjun/emt-server",
      live: "https://manufacturer-tools-adbae.web.app/",
    },
    {
      screen: bsm,
      name: "Book Stock Market (Full Stack)",
      title: "Best Seller All Book Stock Market",
      about:
        "You can find out the all best seller books in the world very easy way. ",
      git: "https://github.com/Jubair-Ahmed-Junjun/book-stock-market/tree/master/client-side",
      server:
        "https://github.com/Jubair-Ahmed-Junjun/book-stock-market/tree/master/server-side",
      live: "https://books-stock-market.web.app/",
    },

    {
      screen: ecommerce,
      name: "E-Shop App (PHP Laravel)",
      title: "Laravel E-commerce Application",
      about:
        "This is a online based shopping website. user can access purchase. and admin also can added or update the products",
      git: "https://github.com/Jubair-Ahmed-Junjun/eshop-app/tree/master/elaravel/lvecommerce",
      live: "https://github.com/Jubair-Ahmed-Junjun/eshop-app/blob/master/E-Shop.pdf",
    },

    {
      screen: teleapp,
      name: "TeleApp (PHP Laravel)",
      title: "Telemedicine Application using PHP Laravel",
      about: "This was my SDP-II project. Created by PHP Laravel Framework",
      git: "https://github.com/Jubair-Ahmed-Junjun/telemedicineapp",
      live: "https://github.com/Jubair-Ahmed-Junjun/telemedicineapp/blob/master/telemedicineapp/Final%20slide%20presentation_JNRS-Team.pdf",
    },

    {
      screen: touristguide,
      name: "Tourist Guide",
      title:
        "Tourist Area, Hotel cost, Necessary Information all are getting here",
      about:
        "This is a website for a travel guide who offers customers many offers by his/her own. this is a simple website user can login and buy his package or contact the guide directly . and theres some travel places also in where customer can know about the tour places they can visit. ",
      git: "https://github.com/JuelHossain/tourboy",
      live: "https://tourist-guide-24ebc.web.app/",
    },
    {
      screen: conventionhall,
      name: "Maisha Convension Hall",
      title: "Convention Centre",
      about: "This is a Single page application.",
      git: "https://github.com/Jubair-Ahmed-Junjun/convention-hall",
      live: "https://jubair-ahmed-junjun.github.io/convention-hall/",
    },
  ];
  return (
    <Container maxW={"container.lg"} className="my-6">
      <Heading
        size={"md"}
        className="text-center uppercase text-3xl mt-12 mb-2"
      >
        Projects I have done
      </Heading>
      <hr className="mb-6 mx-40 border-teal-400" />
      <SimpleGrid columns={[1, 1, 2]} spacing="5">
        {projects.slice(0, size).map((project, index) => {
          const { screen, name, title, about, git, server, live } =
            project ?? {};
          return (
            <ProjectsCard
              key={index}
              screen={screen}
              name={name}
              title={title}
              about={about}
              git={git}
              server={server}
              live={live}
            />
          );
        })}
      </SimpleGrid>
      {home && (
        <Text
          fontSize={"sm"}
          className="rounded py-3 text-2xl text-center my-3 bg-teal-400 dark:bg-red-500"
        >
          Please Visit the Project sections to .
          <Link className="underline" to="/projects">
            See More &rarr;{" "}
          </Link>
        </Text>
      )}
    </Container>
  );
};

export default Projects;
